import { render, staticRenderFns } from "./consultantFiles.vue?vue&type=template&id=2d72572e&"
import script from "./consultantFiles.vue?vue&type=script&lang=js&"
export * from "./consultantFiles.vue?vue&type=script&lang=js&"
import style0 from "./consultantFiles.vue?vue&type=style&index=0&id=2d72572e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports